<template>
  <div class="modalFooter">
    <b-modal
      id="otp__modal"
      v-model="showmodal"
      crm_at="modal_otp_email"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <div :class="currentLocale">
        <div class="modal-title-center-email modal-title">
          {{ lbl.otp.title }}
        </div>
        <button
          type="button"
          class="close-btn-email"
          crm_at="clos_barcode"
          data-dismiss="modal"
          @click="hideModal()"
        >
          <img
            src="@/assets/images/close-icon.svg"
            class="close-icon"
            alt="close-btn"
          />
        </button>
        <img
          class="image-back"
          src="@/assets/images/arrow_back.svg"
          alt=""
          @click="showmodal = false"
        />
        <div class="p__title">
          <div v-if="objRequestOTP.data" crm_at="p_title">
            {{ lbl.otp.sendtomobile }} : {{ data_params.contact_number }}
            <div>
              <span>
                {{ lbl.otp.refcode }}
              </span>
              <span v-if="objRequestOTP.data.refcode" crm_at="refcode">
                {{ objRequestOTP.data.refcode }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-input-otp">
          <v-otp-input
            ref="otpInput"
            class="otp__input"
            input-classes="otp-input"
            :class="{ 'input-expied': isOtpExpied }"
            crm_at="otp_input"
            :separator="windowWidth >= 600 && windowHeight >= 600 ? '' : '-'"
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
          />
        </div>
        <div
          v-if="isOtpExpied"
          class="text__message_otp"
          crm_at="text_message_otp"
          :class="{ 'text-success': isSuccess }"
        >
          {{ validat_otp }}
        </div>

        <div
          v-if="!isOtpExpied"
          class="text__message_otp"
          crm_at="text_message_otp"
          :class="{ 'text-success': isSuccess }"
        >
          {{ please_otp }}
        </div>
        <div crm_at="clicksubmit" @click="clicksubmit">
          <div
            class="btn__submit"
            :style="{
              backgroundColor: storeinfo.buttoncolor,
              border: storeinfo.buttoncolor,
              color: storeinfo.buttontextcolor,
            }"
            :class="{ 'disable-submit': isOtpExpied }"
          >
            <span crm_at="text_submit">{{ text_btn_submit }}</span>
          </div>
        </div>
        <p v-if="!isOtpExpied" class="text-center expire__date">
          <span class="text-time-expired">{{ this.lbl.otp.expired }}</span>
          <span class="time-expired" crm_at="text_expired">{{
            detail_otp.remain_time
          }}</span>
        </p>

        <!-- Support PC Tablet -->
        <div v-if="windowWidth >= 600 && windowHeight >= 600">
          <div class="send-otp-again">
            <span
              class="btn-submit-otp"
              :class="{ 'disable-submit': !isOtpExpied }"
              crm_at="clicksubmit"
              @click="clicksubmit"
            >
              {{ lbl.otp.resend }}
            </span>
          </div>
        </div>

        <!-- Support Mobile -->
        <div v-else>
          <div class="text-center send-otp-again">
            <div
              class="btn btn-outline-secondary"
              :class="{ 'disable-submit': !isOtpExpied }"
              crm_at="clicksubmit"
              :style="{
                backgroundColor: storeinfo.buttoncolor,
                border: storeinfo.buttoncolor,
                color: storeinfo.buttontextcolor,
              }"
              @click="clicksubmit"
            >
              {{ lbl.otp.resend }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BzbsAuth from '@/core/Account/service/BzbsAuth.js'
import Account from '@/helper/AccountHelper.js'
import CommonMixin from '@/mixin/CommonMixin'
import _ from 'lodash'
import moment from 'moment'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Locale from '@/helper/Locale.js'

export default {
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    params: Object,
    resultOtp: Object,
    objProfileInfo: Object,
    referenceInfo: String,
    storeinfo: Object,
    success: Boolean,
    data: Object,
    isSentOtp: Boolean,
  },
  data() {
    return {
      currentLocale: Locale.getLocale(),
      isSuccess: false,
      validat_otp: null,
      please_otp: null,
      showalert: this.isshowalert,
      showmodal: this.isSentOtp,
      input_1: null,
      input_2: null,
      input_3: null,
      input_4: null,
      input_5: null,
      input_6: null,
      data_params: this.params,
      objRequestOTP: {},
      isOtpExpied: false,
      text_btn_submit: null,
      runnigtime: null,
      detail_otp: {
        otp_code: '',
        refcode: '',
        remain_time: '00:00',
        phone_no: '',
        is_timeout: true,
        countdown_limit_sec: 420,
        remain_sec: 0,
        interval: null,
        otp_phone_no: '',
      },
    }
  },
  watch: {
    success: function (newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal == true) {
        this.genInfo(newVal, this.data)
      }
    },
    isSentOtp(val) {
      console.log('watch isSentOtp ::', val)
      this.showmodal = val
      console.log('watch showmodal ::', this.showmodal)
      if (val) {
        this.GetOTP()
      }
    },
    showmodal(val) {
      if (val) {
        this.GetOTP()
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('ChangeCloseOtp', {
        value: false,
      })
      console.log('Modal is about to be shown', bvEvent, modalId)
    })
    this.please_otp = this.lbl.otp.desc
    this.validat_otp = this.lbl.otp.otpincorrect
    this.text_btn_submit = this.lbl.otp.submit
  },
  methods: {
    init() {
      this.handleLoading(false)
      this.GetOTP()
    },
    initializeClock(expiredate) {
      console.log(expiredate)
      this.runCountDown(expiredate)
    },
    genInfo(isSuccess, data) {
      console.log('genInfo', isSuccess, data)
      if (
        isSuccess == true &&
        data.message == undefined &&
        data.id == undefined
      ) {
        this.isSuccess = true
        this.please_otp = this.lbl.otp.otpsuccess
        setTimeout(() => {
          this.showmodal = false
          this.$emit('update:resultOtp', { successotp: true })
        }, 2000)
      } else {
        if (data.message == 'DuplicateEmail' && data.id == 2089) {
          this.please_otp = this.lbl.error.emailregistered
        } else if (data.id == 2078) {
          this.please_otp = this.lbl.error.contactnumberregistered
        } else {
          this.please_otp = this.validat_otp
        }
      }
    },
    runCountDown(expiredate) {
      var otp_remain_sec =
        moment.unix(expiredate).subtract(7, 'hour').unix() - moment().unix() //this.detail_otp.countdown_limit_sec
      this.detail_otp.remain_time = this.getDigitFormatTime(otp_remain_sec)

      this.clearInterval()

      this.detail_otp.interval = setInterval(() => {
        otp_remain_sec = otp_remain_sec - 1
        var remain_sec = otp_remain_sec
        if (remain_sec < 0) {
          remain_sec = 0
        }

        this.detail_otp.remain_time = this.getDigitFormatTime(remain_sec)
        console.log(remain_sec)
        if (remain_sec <= 0) {
          this.detail_otp.is_timeout = true
          this.clearInterval()
          this.validat_otp = this.lbl.otp.otpexpire
          this.changebtntext(true)
          console.log('this.isOtpExpied' + this.isOtpExpied)
        }
      }, 1000)
    },
    clearInterval() {
      try {
        if (this.detail_otp.interval) {
          clearInterval(this.detail_otp.interval)
        }
      } catch (e) {
        //console.log(e.message);
      }
    },
    getDigitFormatTime(remain) {
      var minutes = Math.floor(remain / 60)
      var secs = remain % 60
      return this.harold(minutes) + ':' + this.harold(secs)
    },
    harold(standIn) {
      if (standIn < 10) {
        standIn = '0' + standIn
      }
      return standIn
    },
    changebtntext(fact) {
      this.isOtpExpied = fact
    },
    GetOTP() {
      console.log('params_otp' + JSON.stringify(this.data_params))
      BzbsAuth.apiRequestOTP(this.data_params)
        .then(res => {
          this.isOtpExpied = false
          this.text_btn_submit = this.lbl.otp.submit
          this.isOpenOtp = true
          this.objRequestOTP = res
          this.initializeClock(res.data.expiredate)
          return console.log('OTP ' + JSON.stringify(res))
        })
        .catch(error => {
          console.log(error)
          if (error.response.data.error.message == 'SMS is exceed limit') {
            window.location.href = '/limitotp'
          }
        })
    },
    nextPlease: function (value, before_id, next_id) {
      console.log('nextPlease')
      if (
        value &&
        !_.isEmpty(value) &&
        !_.isNaN(parseInt(value)) &&
        _.isNumber(parseInt(value))
      ) {
        console.log('id_next' + before_id)
        document.getElementById(next_id).focus()
      } else {
        document.getElementById(before_id).value = ''
      }
    },
    clicksubmit() {
      console.log('this.isOtpExpied Click' + this.isOtpExpied)
      if (this.isOtpExpied) {
        console.log('GetOTP')
        this.GetOTP()
      } else {
        console.log('btnconfirmOTP')
        console.log(
          'this.detail_otp.otp_code.length : ' +
            this.detail_otp.otp_code.length,
        )
        if (this.detail_otp.otp_code.length == 6) {
          this.btnconfirmOTP(this.detail_otp.otp_code)
        }
      }
    },
    btnconfirmOTP(strOTP) {
      this.ConfirmOTP(strOTP)
    },
    ConfirmOTP(strOTP) {
      var params = {
        app_id: Account.getCacheCustom('app_id'),
        contact_number: this.data_params.contact_number,
        otp: strOTP,
        refcode: this.objRequestOTP.data.refcode,
      }
      if (this.params.isRegsiter) {
        let data = {
          is_register: true,
          params: params,
        }
        this.$emit('changeOTP', data)
      }

      console.log('res apiConfirmOTP' + JSON.stringify(params))
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$emit('closePopup')
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    handleOnComplete(value) {
      this.detail_otp.otp_code = value
      if (value.length == 6) this.btnconfirmOTP(value)
    },
    handleOnChange(value) {
      console.log('OTP changed: ', value)
      this.please_otp = this.lbl.otp.desc
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput()
    },
  },
}
</script>
<style lang="scss">
@import '@/style/_mixin.scss';
#otp__modal {
  .image-back {
    display: none;
  }
  .text__message_otp {
    color: red;
    text-align: center;
    font-size: 16px;
    margin: 10px 0;
    @include breakpoint-max(320) {
      @include fontSize(16);
    }
  }
  .modal-content {
    border-radius: 10px;
    box-shadow: 0 4px 10px 0 rgb(0 0 0 / 10%);
    border: solid 1px #eee;
    .modal-header {
      border-bottom: none;
      .close {
        display: none;
        font-size: 40px;
        position: absolute;
        top: 0px;
        right: 15px;
        z-index: 1;
      }
      .modal-title {
        font-size: 16px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
  }
  .p__title {
    font-size: 16px;
    color: #999999;
    margin: 2px 36px 27px 36px;
    text-align: center;
    @include breakpoint-max(320) {
      @include fontSize(16);
    }
  }
  .input__otp {
    width: 40px;
    height: 50px;
    border-radius: 10px;
    text-align: center;
    font-size: 35px;
    font-weight: 500;
  }
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 8px;
    li {
      list-style: none;
    }
  }
  .btn__submit {
    width: auto;
    height: 50px;
    @include breakpoint-max(320) {
      height: 40px;
      @include fontSize(16);
    }
    margin: 20px;
    border-radius: 100px;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 35%);
    background-color: #033a70;
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    cursor: pointer;
  }
  .expire__date {
    font-size: 20px;
    @include breakpoint-max(320) {
      @include fontSize(16);
    }
  }
  .time-expired {
    color: #ff6060;
    padding-bottom: 10px;
    display: grid;
  }
  .disable-submit {
    pointer-events: none;
    opacity: 0.3;
  }
  .otp-input {
    width: 100%;
    height: 50px;
    padding: 5px;
    margin: 0 5px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .input-expied {
    pointer-events: none;
    opacity: 0.3;
  }
}

@media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
  #otp__modal {
    .modal-dialog {
      max-width: 550px;
    }
    .image-back {
      position: absolute;
      top: -43px;
      left: 30px;
      display: block;
      cursor: pointer;
    }
    .text__message_otp {
      margin-top: 8px;
      font-size: 14px;
    }
    .modal-content {
      .modal-header {
        justify-content: flex-start;
        align-items: center;
        padding-left: 86px;
        border-bottom: 1px solid #f5f5f5;
        .modal-title {
          font-size: 32px;
          position: unset;
          left: unset;
          transform: unset;
          color: #424242;
        }
        .close {
          display: none;
        }
      }
      .modal-body {
        padding: 22px 40px 40px;
      }
    }
    .p__title {
      margin: 0 0 40px;
    }
    .form-input-otp {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .otp__input {
        width: 80%;
      }
      .otp__input div {
        margin: 0 4px;
      }
    }
    .input-expied {
      opacity: 1;
    }
    .otp-input {
      height: 56px;
      background-color: #fafafa;
      border: 1px solid #eeeeee;
      margin: 0 4px;
    }
    .send-otp-again {
      text-align: -webkit-center;
      margin: 16px 0 0;
      .btn-submit-otp {
        color: #bdbdbd;
        width: 200px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        cursor: pointer;
        font-size: 18px;
      }
      .disable-submit {
        opacity: 0.7;
      }
    }
    .expire__date {
      font-size: unset;
      .text-time-expired {
        font-size: 16px;
        margin-right: 16px;
        color: #757575;
      }
      .time-expired {
        display: unset;
        font-size: 16px;
        color: #2196f3;
        padding-bottom: unset;
      }
    }
    .btn__submit {
      margin: 28px 0 40px;
    }
  }
  .close-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 15px;
    z-index: 1;
  }
}
.modal-title-center-email {
  position: relative;
  top: -20px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}
.close-btn-email {
  background-color: transparent;
  border: none;
  position: absolute;
  right: 20px;
  top: 10px;
  margin: -16px 0;
  .close-icon {
    width: 16px;
    height: 16px;
  }
}
</style>
